import React, { useEffect, useState } from 'react';
import logo from '../img/logo.png';
import { Link, useNavigate } from 'react-router-dom';
import '../css/Loading.css';

// ICONES
import { IonIcon } from '@ionic/react';
import { wifiOutline } from 'ionicons/icons';
import { batteryFullOutline } from 'ionicons/icons';
import { cellularOutline } from 'ionicons/icons';

const Loading = () => {
  
  const navigate = useNavigate();
  
  useEffect(() => {
    const fundo = document.querySelector('.wrapper');
    const timeouts = [
      setTimeout(() => {
        fundo.style.background = "var(--dark)";
      }, 200),
      setTimeout(() => {
        navigate('/app');
      }, 5490)
    ];

    // Limpa os timeouts ao desmontar o componente
    return () => {
      timeouts.forEach(clearTimeout);
    };
  }, []); // O segundo argumento do useEffect, um array vazio, indica que a função será executada somente após o primeiro render


  // RELOGIO
  const [horaAtual, setHoraAtual] = useState(new Date());

  useEffect(() => {
    
    const intervalId = setInterval(() => {
      setHoraAtual(new Date());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const formatDigit = (digit) => (digit < 10 ? '0' + digit : digit);

  const horas = formatDigit(horaAtual.getHours());
  const minutos = formatDigit(horaAtual.getMinutes());
  const segundos = formatDigit(horaAtual.getSeconds());

  return (
    <main className="container-loading">
      <div className="before">
        <p id="hora">
          {horas}:{minutos}:{segundos}
        </p>

        <div className="flex">
          <IonIcon icon={wifiOutline} />
          <IonIcon icon={cellularOutline} />
          <IonIcon icon={batteryFullOutline} />
        </div>
      </div>

      <div class="wrapper">
        <svg>
          <text x="50%" y="50%" dy=".35em" text-anchor="middle">
            E.E Letícia
          </text>
        </svg>
      </div>
      
    </main>
  );
};


export default Loading;